<template>
  <div :id="componentId" class="sp1-agenda-section" :style="sectionStyle">
    <div class="sp1-text-wrapper_44 flex-row justify-between">
      <span class="sp1-text_30">{{ dateText }}</span>
      <span class="sp1-text_31">{{ weekText }}</span>
    </div>
    <div id="sp_one_agenda" class="sp1-agenda-body flex-row">
      <img
        class="sp1-image_18"
        referrerpolicy="no-referrer"
        src="../assets/img/FigmaDDSSlicePNGaba263122e8796d6e93523252ce0c689.png"
      />
      <div class="sp1-agenda-labels flex-col justify-between">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          :class="['sp1-agenda-label flex-row', { 'is-empty': !item.label, 'is-main': item.isMain }]"
        >
          <span class="sp1-agenda-label-text">{{ item.label }}</span>
          <div
            v-if="item.label"
            class="sp1-agenda-marker flex-col"
            :class="{ 'is-main': item.isMain }"
          ></div>
        </div>
      </div>
      <div class="sp1-agenda-rows flex-col justify-between">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="sp1-agenda-row flex-row"
          :style="rowStyle"
        >
          <span class="sp1-agenda-time">{{ item.time }}</span>
          <span class="sp1-agenda-title">{{ item.title }}</span>
          <div class="sp1-agenda-meta flex-row">
            <span v-if="item.speaker" class="sp1-agenda-speaker">{{ item.speaker }}</span>
            <span class="sp1-agenda-role">{{ item.role }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgendaSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_7'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      rowBackgroundImage: require('../assets/img/FigmaDDSSlicePNGc8f4d5f56f8d6959e077f3d570c65ddd.png'),
      dateText: '12/20',
      weekText: '星期四',
      items: [
        {
          label: '致 辞',
          isMain: true,
          time: '9:30-9:40',
          title: '开场致辞',
          speaker: '社领导',
          role: ''
        },{
          label: '',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '主旨演讲',
          isMain: true,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '品牌发布',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '品牌推动',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '合作签约',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    rowStyle() {
      return {
        backgroundImage: `url(${this.rowBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center'
      };
    }
  }
};
</script>

<style scoped>
.sp1-agenda-section {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 39px;
}

.sp1-agenda-body {
  width: 1400px;
  margin-top: 14px;
  margin-left: 7px;
  align-items: stretch;
}

.sp1-image_18 {
  width: 1px;
  height: auto;
}

.sp1-agenda-labels {
  width: 297px;
  margin-left: 0;
}

.sp1-agenda-label {
  position: relative;
  width: 297px;
  height: 71px;
  background-color: rgba(243, 246, 243, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  align-items: center;
}

.sp1-agenda-label + .sp1-agenda-label {
  margin-top: 20px;
}

.sp1-agenda-label.is-empty {
  background-color: transparent !important;
  border-color: transparent !important;
}

.sp1-agenda-label-text {
  overflow-wrap: break-word;
  color: rgba(43, 131, 120, 1);
  font-size: 26px;
  letter-spacing: 1.529411792755127px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  margin-left: 22px;
}

.sp1-agenda-marker {
  position: absolute;
  left: -7px;
  top: 30px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(151, 151, 151, 1);
}

.sp1-agenda-marker.is-main {
  left: -5px;
  top: 23px;
  width: 8px;
  height: 25px;
  border-radius: 5px;
  background-color: rgba(43, 131, 120, 1);
  border: none;
}

.sp1-agenda-rows {
  width: 1041px;
  margin-left: 15px;
}

.sp1-agenda-row {
  width: 1041px;
  height: 71px;
  align-items: center;
  padding: 0 42px;
}

.sp1-agenda-row + .sp1-agenda-row {
  margin-top: 20px;
}

.sp1-agenda-time {
  width: 160px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(43, 131, 120, 1);
  font-size: 24px;
  letter-spacing: 1.4117647409439087px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.sp1-agenda-title {
  margin-left: 37px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(43, 131, 120, 1);
  font-size: 24px;
  letter-spacing: 1.4117647409439087px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.sp1-agenda-meta {
  margin-left: 180px;
  align-items: center;
}

.sp1-agenda-speaker {
  width: 80px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  letter-spacing: 1.1764706373214722px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.sp1-agenda-role {
  margin-left: 31px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  letter-spacing: 1.1764706373214722px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}
</style>
